import { Component, Input } from '@angular/core';

@Component({
  selector: 'lp2-activity-item',
  templateUrl: './activity-item.component.html',
  styleUrls: ['./activity-item.component.scss'],
})
export class ActivityItemComponent {
  @Input() imageSource: string;
  @Input() count: number;
  @Input() title: string;
  constructor() {}
}



// WEBPACK FOOTER //
// ./ts/app/activity-registry/activity-item/activity-item.component.ts